// Until we have better, should match Constants/OrganizationConstants.php in the Rest API

enum EnumPermissions {
  ACTIVATION = 'activation',
  BILLING = 'billing',
  BILLING_VISIBLE = 'billing_visible',
  CHANGEPLAN = 'changeplan',
  DEACTIVATE = 'deactivate',
  ORG_MANAGEMENT = 'org_management',
  SBCONFIG = 'sbconfig',
  SBTUNNEL = 'sbtunnel',
}

export default EnumPermissions;
